import { Component, OnInit } from '@angular/core';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { ActivityHistory, ConfirmHistory, User, UserChannel, UserPaymentInfo } from 'src/app/models/user';
import { CommonService } from 'src/app/services/common.service';
import { UserService } from 'src/app/services/user.service';
import { MypageCommonDialogComponent } from '../../mypage/mypage-common-dialog/mypage-common-dialog.component';
import { ImageViewerComponent } from '../../image-viewer/image-viewer.component';
import { UserConfirmDialogComponent } from '../../user/user-confirm-dialog/user-confirm-dialog.component';
import { AuthService } from 'src/app/services/auth.service';
import { Content, ContentSearch } from 'src/app/models/content';
import { ContentService } from 'src/app/services/content.service';
import * as moment from 'moment';
import { UAParser } from 'ua-parser-js';
import { HistorySearch, LinkStats } from 'src/app/models/buddy';
import { Pagination } from 'src/app/models/common';
import { BuddyService } from 'src/app/services/buddy.service';

@Component({
  selector: 'app-mobile-mypage',
  templateUrl: './mobile-mypage.component.html',
  styleUrls: ['./mobile-mypage.component.css']
})
export class MobileMypageComponent implements OnInit {

  constructor(
    private userService: UserService,
    private commonService: CommonService,
    private authService: AuthService,
    private contentService: ContentService,
    private spinner: NgxSpinnerService,
    private matDialog: MatDialog,
    private router: Router,
    private buddyService: BuddyService
  ) {
    if(!this.commonService.getIsMobile()) {
      this.router.navigate(['/mypage'])
    }
  }

  userNo: number
  ngOnInit(): void {
    this.userNo = this.commonService.getUserInfo().userNo
    this.getUserInfo()
    this.getNoticeList()
    this.getQnaList()
    this.getLinkStatsHistoryList()
  }
  user: User = new User()
  channelList: UserChannel[]

  userPaymentInfo: UserPaymentInfo
  confirmHistoryList: ConfirmHistory[]
  activityHistoryList: ActivityHistory[]
  loginHistoryList: ActivityHistory[]
  etcHistoryList: ActivityHistory[]
  historyTab: string = 'login'
  selectHistoryTab(tab: string) {
    this.historyTab = tab
  }
  getUserInfo() {
    //this.spinner.show()
    this.userService.getUserInfo(this.userNo).subscribe(res => {
      //this.spinner.hide()
      this.user = res.data.user
      this.channelList = res.data.channelList
      this.confirmHistoryList = res.data.confirmHistoryList
      this.userPaymentInfo = res.data.userPaymentInfo
      this.activityHistoryList = res.data.userActivityHistoryList
      if(this.activityHistoryList) {
        this.activityHistoryList.forEach(ah => {
          let ua = new UAParser(ah.userAgent)
          ah.browser = ua.getBrowser().name
          ah.os = ua.getOS().name
        })
      }
      this.loginHistoryList = this.activityHistoryList.filter(ah => ah.activityType == 'LOGIN')
      if(this.loginHistoryList && this.loginHistoryList.length > 3) {
        this.loginHistoryList = this.loginHistoryList.slice(0, 3)
      }
      this.etcHistoryList = this.activityHistoryList.filter(ah => ah.activityType != 'LOGIN')
    })
  }
  list: LinkStats[]
  getLinkStatsHistoryList() {
    this.spinner.show();
    let search = new HistorySearch()
    search.refererGroup = ''
    search.fromDate = moment(new Date()).add(1, 'day').add(-1, 'M')
    search.toDate = moment(new Date())
    search.searchDateType = 'eventDate'
    search.searchType = 'title'
    this.buddyService.getLinkStatsHistoryList(search).subscribe(res => {
      this.spinner.hide()
      this.list = res.data.content
    })
  }
  removeChannel(item: UserChannel) {
    if(confirm("정말 삭제하시겠습니까?")) {
      this.spinner.show()
      this.userService.removeChannel(item.userChannelNo).subscribe(res => {
        this.spinner.hide()
        alert("정상적으로 삭제 되었습니다.")
        this.getUserInfo()
      })
    }
  }
  openMypageCommonPopup(type: string) {
    if(type == 'updateAccount' || type == 'updateCorpCode') {
      let today = moment(new Date()).get('D')
      if(!(today > 20 || today < 7)) {
        return alert('계좌정보 수정 가능 기간은 매월 21일부터 익월 6일까지 가능합니다.')
      }
    }
    const dialogConfig = new MatDialogConfig()
    dialogConfig.disableClose = false
    dialogConfig.id = "mypageCommonWindow"
    //dialogConfig.width = "640px"
    //dialogConfig.height = "600px"
    dialogConfig.data = {
        userNo: this.userNo
      , type: type
      , user: this.user
      , userPaymentInfo: this.userPaymentInfo
    }
    const matDialog = this.matDialog.open(MypageCommonDialogComponent, dialogConfig);
    matDialog.afterClosed().subscribe(res => {
      this.getUserInfo()
    })
  }
  openAddScreenshotPopup(item: UserChannel) {
    const dialogConfig = new MatDialogConfig()
    dialogConfig.disableClose = false
    dialogConfig.id = "mypageCommonWindow"
    dialogConfig.data = {
        userNo: this.userNo
      , type: 'addScreenshot'
      , userChannel: item
    }
    const matDialog = this.matDialog.open(MypageCommonDialogComponent, dialogConfig);
    matDialog.afterClosed().subscribe(res => {
      this.getUserInfo()
    })
  }
  removeScreenshot(item: UserChannel) {
    if(confirm("이미지를 정말 삭제하시겠습니까?")) {
      this.spinner.show()
      this.userService.removeScreenshot(item.userChannelNo).subscribe(res => {
        this.spinner.hide()
        alert("정상적으로 삭제 되었습니다.")
        this.getUserInfo()
      })
    }
  }
  leaveBuddy() {
    if(confirm('탈퇴 시 모든 정보는 삭제되며, 복구가 불가능합니다.\n정말 탈퇴하시겠습니까?')) {
      alert('준비중입니다.')
    }
  }
  openImageViewerDialog(imageFilePath: string) {
    const dialogConfig = new MatDialogConfig()
    dialogConfig.disableClose = true
    dialogConfig.id = "imageViewerDialogWindow"
    //dialogConfig.width = "900px"
    //dialogConfig.height = "900px"
    dialogConfig.data = {list:[imageFilePath]}
    this.matDialog.open(ImageViewerComponent, dialogConfig);
  }
  openConfirmPopup(status: string) {
    const dialogConfig = new MatDialogConfig()
    dialogConfig.disableClose = false
    dialogConfig.id = "userConfirmWindow"
    dialogConfig.data = {
        status: status
      , user: this.user
      , confirmHistoryList: this.confirmHistoryList
    }
    const matDialog = this.matDialog.open(UserConfirmDialogComponent, dialogConfig);
    matDialog.afterClosed().subscribe(res => {
      this.getUserInfo()
    })
  }

  noticeList: Content[]
  getNoticeList() {
    let search = new ContentSearch()
    search.fromDate = null
    search.toDate = null
    search.contentMasterId = 'NOTICE'
    search.statusList = ['ON']
    search.rows = 2
    this.spinner.show();
    this.contentService.getContentList(search).subscribe(res => {
      this.spinner.hide()
      this.noticeList = res.data.content
    })
  }
  qnaList: Content[]
  getQnaList() {
    let search = new ContentSearch()
    search.fromDate = null
    search.toDate = null
    search.contentMasterId = 'QNA'
    search.statusList = ['ON']
    search.rows = 2
    this.spinner.show();
    this.contentService.getContentList(search).subscribe(res => {
      this.spinner.hide()
      this.qnaList = res.data.content
    })
  }
  openContentDetailWindow(masterId: string, contentNo: number) {
    var width = 1400 //screen.availWidth - 150
    var height = 800 //screen.availHeight - 250
    var windowPopup = window.open('/popup/voc/' + masterId + '/' + contentNo, 'contentAddWindow_' + contentNo, 'width='+width/13*11+',height='+height+',left='+width/13*4+',top=0,scrollbars=no');
    windowPopup.focus();
  }

  logout(){
    this.authService.logout()
  }
}
